import {component, getComposedDataList} from '../components/form/Constant'
import {observationKeys} from '../components/observations/Constants'
import {convertSkinTempToMBT} from '../components/observations/Utils'
import {
    parameterKeys,
    parameterList,
} from '../components/parameter/ParameterConstants'
import {convertKeyToLabel} from '../components/table-utils/TableUtils'
import {aiFormKeys, aiOptionsValue, obsAiDataList} from './AIConstant'
function convertParameterToString(parameterData) {
    let parameter = getComposedDataList(parameterList, parameterData)[0]
        ?.children
    let string = ' '
    let stringList = []

    if (parameter && Array.isArray(parameter) && parameter.length > 0) {
        for (let i = 0; i < parameter.length; i++) {
            if (parameter[i].key !== parameterKeys.comment) {
                if (parameter[i]?.key && parameter[i]?.initialValue) {
                    let item = `${convertKeyToLabel(parameter[i].key)} : ${
                        parameter[i]?.initialValue
                    }`

                    stringList.push(item)
                }
            }
        }

        string = stringList.join(', ')
    }

    return string
}

export const includeObsKeys = [
    observationKeys.respiration,
    observationKeys.oxygen,
    observationKeys.bloodPressure,
    observationKeys.heartRate,
    observationKeys.temperature,
    observationKeys.systolic,
    observationKeys.diastolic,
    observationKeys.bloodGlucoseLevel,
]

function convertObsDataToString(obsData, aiData = {}) {
    let string = ''
    if (obsData && Array.isArray(obsData) && obsData.length > 0) {
        let stringList = []
        let length = 0
        if (aiData[aiFormKeys.record] > 0) {
            if (obsData.length > aiData[aiFormKeys.record]) {
                length = aiData[aiFormKeys.record]
            } else {
                length = obsData.length
            }
        }
        for (let i = 0; i < length; i++) {
            let objItem = obsData[i]
            let stringItemList = []
            for (const key in objItem) {
                let isInclude = aiData[aiFormKeys.compareWith]?.includes(key)

                if (!!isInclude && !!objItem[key]) {
                    let stringItem = `${convertKeyToLabel(key)}: ${
                        objItem[key]
                    } `
                    stringItemList.push(stringItem)
                }
            }

            if (stringItemList.length > 0) {
                stringList.push(
                    `${obsData[i][observationKeys.date]} ${
                        obsData[i][observationKeys.time]
                    } - ${stringItemList.join(',')}`,
                )
            }
        }

        string = stringList.join(',')
    }

    return string
}

const parseKeysData = (keyList, dataList) => {
    let result = {}

    keyList.forEach(key => {
        result[key] = []
    })

    dataList.forEach(data => {
        keyList.forEach(key => {
            if (
                (key !== observationKeys.bloodPressure &&
                    data.hasOwnProperty(key) &&
                    data[key]) ||
                (key === observationKeys.bloodPressure &&
                    data.hasOwnProperty(observationKeys.systolic) &&
                    data.hasOwnProperty(observationKeys.diastolic) &&
                    data[observationKeys.systolic] &&
                    data[observationKeys.diastolic])
            ) {
                if (key === observationKeys.temperature) {
                    if (data['device'] === 'W') {
                        result[key].push(convertSkinTempToMBT(data[key]))
                    } else {
                        result[key].push(data[key])
                    }
                } else if (key === observationKeys.bloodPressure) {
                    if (
                        data[observationKeys.diastolic] &&
                        data[observationKeys.systolic]
                    ) {
                        result[key].push(
                            `diastolic: ${
                                data[observationKeys.diastolic]
                            } + '/' + systolic: ${
                                data[observationKeys.systolic]
                            }`,
                        )
                    }
                } else {
                    result[key].push(data[key])
                }
            }
        })
    })

    for (let key in result) {
        result[key] = result[key].join(', ')
    }

    return result
}

export function convertObsDataToAIValue(
    obsData = [],
    parameterData = {},
    aiData = [],
) {
    if (!obsData || !Array.isArray(obsData) || obsData?.length < 1) {
        return ''
    }

    let startDate =
        obsData[0].year + '-' + obsData[0].date + ' ' + obsData[0].time
    let endDate = ''
    if (obsData.length > 1) {
        endDate =
            obsData[obsData.length - 1].year +
            '-' +
            obsData[obsData.length - 1].date +
            ' ' +
            obsData[obsData.length - 1].time
    }

    const dataFromKeys = parseKeysData(
        [...aiData[aiFormKeys.compareWith]],
        obsData,
    )

    let observationPromptString = ''
    aiData[aiFormKeys.compareWith].forEach(key => {
        observationPromptString += ` ${convertKeyToLabel(key)}: ${
            dataFromKeys[key]
        }`
    })

    let parameterPromptString = ''
    Object.keys(parameterData).forEach(key => {
        if (aiData[aiFormKeys.compareWith]?.includes(key)) {
            parameterPromptString += ` ${key}: ${parameterData[key]}`
        }
    })

    if (!observationPromptString) {
        return ''
    }

    const dateFromTo = !endDate
        ? `since ${startDate}`
        : `from ${startDate} to ${endDate}`

    return `Can you provide a summary of health observations ${dateFromTo}  based on the following parameters set for this patient: ${parameterPromptString} and the following observations: ${observationPromptString} `
}

export function getCompareWithOption() {
    let option = []

    if (
        includeObsKeys &&
        Array.isArray(includeObsKeys) &&
        includeObsKeys.length > 0
    ) {
        option = includeObsKeys.map(item => {
            return {label: convertKeyToLabel(item), value: item}
        })
    }

    return option
}

export function getAiDataList(data = {}, isObsForm = false) {
    let list = [
        {
            key: aiFormKeys.question,
            label: 'Add your suggestions',
            placeholder: 'Input your suggestions here',
            component: component.inputTextArea,
            isShow: true,
        },
    ]
    if (!!isObsForm) {
        let holderList = []
        for (let i = 0; i < obsAiDataList.length; i++) {
            let item = {...obsAiDataList[i]}
            if (!obsAiDataList[i].isShow) {
                if (
                    data[aiFormKeys.observation] === aiOptionsValue.compareWith
                ) {
                    if (obsAiDataList[i].key === aiFormKeys.compareWith) {
                        item.options = getCompareWithOption()
                        item.isShow = true
                    } else if (obsAiDataList[i].key === aiFormKeys.record) {
                        if (
                            data[aiFormKeys.compareWith] &&
                            Array.isArray(data[aiFormKeys.compareWith]) &&
                            data[aiFormKeys.compareWith].length > 0
                        ) {
                            item.isShow = true
                        }
                    }
                }

                holderList.push(item)
            } else {
                holderList.push(item)
            }
        }

        list = [...holderList, ...list]
    }
    return list
}
